import React from "react";

type Props = {
    id: any;
    label?: string
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export default function Range(props: Props) {

    return (
        <>
            <label
                dangerouslySetInnerHTML={{
                    __html: props.label,
                }}
                htmlFor={props.id}
            >
            </label>
            <input
                {...props}
                type="range"
            />
        </>
    );
}
